import styles from './modal.module.scss';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import { useAuth, useUser } from 'contexts';
import Routes, { accountRoutes } from 'data/routes';
import useModal from 'hooks/useModal';
import { useRouter } from 'next/navigation';
import PropTypes from 'prop-types';
import { Confirm, Flex, Icon, Image, Modal } from 'ui';

function AccountMenu({ children }) {
  const [open, { handleOpen, handleClose }] = useModal();
  const { logout, user } = useAuth();
  const { profile } = useUser();

  const router = useRouter();

  const handleRedirect = (path) => {
    router.push(path);
    handleClose();
  };

  return (
    <>
      <Box
        onClick={() => {
          if (!profile.name) return;
          handleOpen();
        }}
      >
        {children}
      </Box>
      <Modal className={styles.root} onClose={handleClose} open={open}>
        <Stack className={styles.account} spacing={3}>
          <Stack className={styles.item} spacing={0.5}>
            {profile.name ? (
              profile.photoURL ? (
                <Image
                  alt="profile"
                  className={styles.profile}
                  height={60}
                  loading="eager"
                  src={profile.photoURL}
                  width={60}
                />
              ) : (
                <Avatar className={styles.profile}>
                  {profile.name.charAt(0)}
                </Avatar>
              )
            ) : (
              <Icon
                className={classnames(styles.profile, styles.circle)}
                name="account_circle"
              />
            )}
            <Stack spacing={0.5}>
              <Typography variant="h6">{profile.name}</Typography>
              <Typography variant="span">{user?.email}</Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack className={styles.container}>
          <Stack className={styles.menu}>
            {accountRoutes.map(({ href, label }) => (
              <Flex
                key={href}
                className={styles.item}
                spacing={0.5}
                onClick={() => handleRedirect(href)}
              >
                <Typography variant="span">{label}</Typography>
              </Flex>
            ))}
            <Confirm
              title="Invita y gana"
              description={[
                '¡Invita a tus amigos a usar Monus y gana dinero real! Podrás ganar hasta $3.000 por cada persona que se suscriba por primera vez a un plan.',
                `${!profile?.handle && 'Para obtener un enlace de invitación ingresa a mi cuenta y elige un nombre de usuario.'}`,
              ]}
              confirmText={profile?.handle ? 'Copiar enlace' : 'Ir a mi cuenta'}
              onConfirm={() => {
                profile?.handle
                  ? navigator.clipboard.writeText(
                      process.env.MONUS_REFFERAL + '/' + profile?.handle
                    )
                  : handleRedirect(Routes.account);
                handleClose();
              }}
            >
              <Flex className={styles.item}>
                <Typography variant="span">Invitar amigos</Typography>
              </Flex>
            </Confirm>
            <Flex
              className={styles.item}
              hidden={!profile.name}
              onClick={() => {
                logout();
                handleClose();
                handleRedirect(Routes.home);
              }}
              spacing={0.5}
            >
              <Typography variant="span">Cerrar sesión</Typography>
            </Flex>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
}

AccountMenu.propTypes = {
  profile: PropTypes.object,
  loading: PropTypes.bool,
};

export default AccountMenu;
